var Bavaria = "巴伐利亚州";
var Berlin = "柏林";
var Brandenburg = "勃兰登堡";
var Bremen = "不来梅港市";
var Hamburg = "汉堡";
var Hesse = "黑森州";
var Saarland = "萨尔州";
var Saxony = "萨克森州";
var Thuringia = "图林根州";
var DEStates = {
	"Baden-Wuerttemberg": "巴登-符腾堡州",
	Bavaria: Bavaria,
	Berlin: Berlin,
	Brandenburg: Brandenburg,
	Bremen: Bremen,
	Hamburg: Hamburg,
	Hesse: Hesse,
	"Mecklenburg-Vorpommern": "梅克伦堡-福尔波门州",
	"Lower Saxony": "下萨克森州",
	"North Rhine-Westphalia": "北莱因-威斯特伐利亚州",
	"Rhineland-Palatinate": "莱茵兰-普法尔茨州",
	Saarland: Saarland,
	Saxony: Saxony,
	"Saxony-Anhalt": "萨克森-安哈尔特州",
	"Schleswig-Holstein": "石勒苏益格-荷尔斯泰因",
	Thuringia: Thuringia
};

export { Bavaria, Berlin, Brandenburg, Bremen, Hamburg, Hesse, Saarland, Saxony, Thuringia, DEStates as default };
